export function addThousandSeparator(number) {
  const reg = /(\d)(?=(?:\d{3})+$)/g;
  let newNumber = number.split(".");
  return (
    newNumber[0].replace(reg, "$1,") +
    (typeof newNumber[1] !== "undefined" ? "." + newNumber[1] : "")
  );
}
export function removeThousandSeparator(number) {
  return String(number).replace(/,/g, "");
}

export const emailPattern = /^[\w\.]+@\w+((\.|-)\w+)+$/;
export const passwordPattern =
  /^(?=.*\d)(?=.*[a-zA-Z])(?!.*[^\x00-\xff]).{8,}.*$/;
export const mobilePattern = /^[0-9]{10}$/;

export const identity = localStorage.getItem("@fullhouseIdentity") === "STAFF";
